import { MedicalRef } from './medical-ref.model';

export const VETERINARY_CONTACT_TYPE = 'veterinarian';

export interface AnimalVeterinaryContactModel {
  id: number;
  animal?: MedicalRef;
  contact: MedicalRef;
  type: string | null;
  label: string | null;
  isPrimary: boolean;
}

export interface AnimalVeterinaryContactCreatePayload {
  animal: { id: number };
  contact: { id: number };
  type: string;
  label: string | null;
  isPrimary: boolean;
}

export type AnimalVeterinaryContactUpdatePayload = Partial<Omit<AnimalVeterinaryContactCreatePayload, 'animal'>>;
